export default "__VITE_ASSET__Bs8$YbIJ__"